var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-key",
    "data-name": "Icon awesome-key",
    d: "M20,6.875a6.879,6.879,0,0,1-8.157,6.755L10.9,14.685a.937.937,0,0,1-.7.315H8.75v1.562a.937.937,0,0,1-.937.938H6.25v1.563A.937.937,0,0,1,5.313,20H.938A.937.937,0,0,1,0,19.063V16.013a.938.938,0,0,1,.275-.663l6.32-6.32A6.876,6.876,0,1,1,20,6.875ZM13.125,5A1.875,1.875,0,1,0,15,3.125,1.875,1.875,0,0,0,13.125,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordKey);
export default __webpack_public_path__ + "static/media/password-key.90519a3b0cf90eca0ebd310e44f52346.svg";
export { ForwardRef as ReactComponent };